<template>
    <div class="wrapper">
        <checkpoint v-if="!$store.state.authentication.checked"></checkpoint>
        
        <template v-if="$store.state.authentication.loggedIn && $store.state.authentication.checked">
            <Header />
            <side-bar>
                <sidebar-link to="/dashboard">
                    <md-icon>dashboard</md-icon>
                    <p>{{translate(locale.dashboard)}}</p>
                </sidebar-link>

                <div
                    style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);">
                </div>
                <sidebar-link to="/system_log">
                    <md-icon>pending_actions</md-icon>
                    <p>{{translate(locale.systemLog)}}</p>
                </sidebar-link>
                <sidebar-link to="/system_clients">
                    <md-icon>memory</md-icon>
                    <p>{{translate(locale.systemClients)}}</p>
                </sidebar-link>

                <template v-if="$store.state.authentication.user_role == 'super-admin'">
                    <div
                        style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);">
                    </div>
                    <sidebar-link to="/administrators">
                        <md-icon>supervised_user_circle</md-icon>
                        <p>{{translate(locale.administrators)}}</p>
                    </sidebar-link>
                    <sidebar-link to="/settings">
                        <md-icon>settings</md-icon>
                        <p>{{translate(locale.settings)}}</p>
                    </sidebar-link>
                </template>
            </side-bar>

            <div class="main-panel" style="padding-top:80px">

                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>

                <Footer />
            </div>
        </template>
    </div>
</template>

<script>
    import Footer from '../components/Footer.vue'
    import Header from '../components/Header.vue'
    import Checkpoint from './Checkpoint.vue'

    export default {
        created() {

            if (String(this.$store.state.authentication.authToken).length < 64 || this.$store.state.authentication.authToken == null) {
                this.$store.state.authentication.checked = true;
                this.$router.push("/login");
            } else {
                this.$http.get(this.config.api + "/admin/authenticate").then(res => {

                    if (res.body.status == 'success') {
                        this.$store.state.authentication.loggedIn = true;
                        this.$store.state.authentication.user_hash = res.body.data.user_hash;
                        this.$store.state.authentication.user_name = res.body.data.user_name;
                        this.$store.state.authentication.user_role = res.body.data.user_role;
                        this.$store.state.authentication.checked = true;
                    }
                })
            }
        },
        components: { Header, Footer, Checkpoint }

    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// src/pages/Layout.vue